import type * as Types from 'app/types/graphql';

export type VariantUrlSelectFragment = Pick<
  Types.VariantUrl,
  'id' | 'baseID' | 'handle' | 'title' | 'redirectURL' | 'resourceType'
>;

export const VariantUrlSelectFragmentDoc = `
    fragment VariantURLSelect on VariantURL {
  id
  baseID
  handle
  title
  redirectURL
  resourceType
}
    `;
